import { render } from "./Medication.vue?vue&type=template&id=0d8b6f2f&scoped=true"
import script from "./Medication.vue?vue&type=script&lang=js"
export * from "./Medication.vue?vue&type=script&lang=js"

import "./Medication.vue?vue&type=style&index=0&id=0d8b6f2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8b6f2f"]])

export default __exports__